/*
 * @Description: 谷仓海外销售路由模块
 * @Author: mdb
 * @Date: 2023-03-02 16:33:31
 * @LastEditTime: 2023-06-19 13:26:53
 * @LastEditors: cxh
 */
import Layout from '@/layout/index.vue'

const routerItem = {
  path: '/ofbu',
  component: Layout,
  children: [
    {
      path: 'index',
      name: 'DcCosOFbuIndex',
      meta: { title: '首页', noCache: true },
      component: require('@/views/overseasSales/index/index.vue').default
    },
    {
      path: 'salesClue',
      name: 'DcCosOFbuSalesClue',
      meta: { title: '销售线索' },
      component: require('@/views/overseasSales/clueManage/salesClue/index.vue').default
    },
    {
      path: 'salesClue/view',
      name: 'DcCosOFbuSalesClueView',
      meta: { title: '销售线索详情', noCache: true },
      component: require('@/views/overseasSales/clueManage/salesClue/view.vue').default
    },
    {
      path: 'salesClue/add',
      name: 'DcCosOFbuSalesClueAdd',
      meta: { title: '添加销售线索' },
      component: require('@/views/overseasSales/clueManage/salesClue/add.vue').default
    },
    {
      path: 'salesClue/edit',
      name: 'DcCosOFbuSalesClueEdit',
      meta: { title: '编辑销售线索' },
      component: require('@/views/overseasSales/clueManage/salesClue/edit.vue').default
    },
    {
      path: 'publicClue',
      name: 'DcCosOFbuPublicClue',
      meta: { title: '线索公海池' },
      component: require('@/views/overseasSales/clueManage/publicClue/index.vue').default
    },
    {
      path: 'publicClue/view',
      name: 'DcCosOFbuPublicClueView',
      meta: { title: '公海池详情', noCache: true },
      component: require('@/views/overseasSales/clueManage/salesClue/view.vue').default
    },
    {
      path: 'potential',
      name: 'DcCosOFbuPotential',
      meta: { title: '潜在客户' },
      component: require('@/views/overseasSales/customerCenter/potential/index.vue').default
    },
    {
      path: 'potential/view',
      name: 'DcCosOFbuPotentialView',
      meta: { title: '潜在客户详情', noCache: true },
      component: require('@/views/overseasSales/customerCenter/potential/view/index.vue').default
    },
    {
      path: 'potential/perfect',
      name: 'DcCosOFbuPotentialPerfect',
      meta: { title: '潜在客户完善资料' },
      component: require('@/views/overseasSales/customerCenter/potential/perfect/index.vue').default
    },
    // {
    //   path: 'potential/add',
    //   name: 'DcCosOFbuPotentialAdd',
    //   meta: { title: '潜在客户新增' },
    //   component: require('@/views/overseasSales/customerCenter/potential/edit/index.vue').default
    // },
    {
      path: 'potential/edit',
      name: 'DcCosOFbuPotentialPerEdit',
      meta: { title: '潜在客户编辑' },
      component: require('@/views/overseasSales/customerCenter/potential/edit/index.vue').default
    },
    {
      path: 'turnToContract',
      name: 'DcCosOFbuTurnToContract',
      meta: { title: '转签约' },
      component: require('@/views/overseasSales/customerCenter/turnToContract/index.vue').default
    },
    {
      path: 'customerActive',
      name: 'DcCosOFbuCustomerActive',
      meta: { title: '流失激活' },
      component: require('@/views/overseasSales/customerCenter/lossToActive/index.vue').default
    },
    {
      path: 'contract',
      name: 'DcCosOFbuContract',
      meta: { title: '签约客户' },
      component: require('@/views/overseasSales/customerCenter/contract/index.vue').default
    },
    {
      path: 'contract/view',
      name: 'DcCosOFbuContractView',
      meta: { title: '签约客户详情', noCache: true },
      component: require('@/views/overseasSales/customerCenter/contract/view/index.vue').default
    },
    {
      path: 'contract/edit',
      name: 'DcCosOFbuContractEdit',
      meta: { title: '签约客户编辑' },
      component: require('@/views/overseasSales/customerCenter/contract/edit/index.vue').default
    },
    {
      path: 'turnToDeal',
      name: 'DcCosOFbuTurnToDeal',
      meta: { title: '转成交' },
      component: require('@/views/overseasSales/customerCenter/turnToDeal/index.vue').default
    },
    {
      path: 'clients',
      name: 'DcCosOFbuClients',
      meta: { title: '成交客户' },
      component: require('@/views/overseasSales/customerCenter/clients/index.vue').default
    },
    {
      path: 'clients/view',
      name: 'DcCosOFbuClientsView',
      meta: { title: '成交客户详情', noCache: true },
      component: require('@/views/overseasSales/customerCenter/clients/view/index.vue').default
    },
    {
      path: 'clients/edit',
      name: 'DcCosOFbuClientsEdit',
      meta: { title: '成交客户编辑' },
      component: require('@/views/overseasSales/customerCenter/clients/edit/index.vue').default
    },
    {
      path: 'accountCode',
      name: 'DcCosOFbuAccountCode',
      meta: { title: '客户代码' },
      component: require('@/views/overseasSales/customerCenter/accountCode/index.vue').default
    },
    {
      path: 'accountCode/view',
      name: 'DcCosOFbuAccountCodeDetail',
      meta: { title: '客户代码详情', noCache: true },
      component: require('@/views/overseasSales/customerCenter/accountCode/detail/index.vue').default
    },
    {
      path: 'mainBody',
      name: 'DcCosOFbuMainBody',
      meta: { title: '签约主体' },
      component: require('@/views/overseasSales/customerCenter/mainBody/index.vue').default
    },
    {
      path: 'business',
      name: 'DcCosOFbuBusiness',
      meta: { title: '商机管理' },
      component: require('@/views/overseasSales/chanceManage/business/index.vue').default
    },
    {
      path: 'business/add',
      name: 'DcCosOFbuBusinessAdd',
      meta: { title: '新增商机' },
      component: require('@/views/overseasSales/chanceManage/business/add.vue').default
    },
    {
      path: 'business/view',
      name: 'DcCosOFbuBusinessView',
      meta: { title: '商机详情', noCache: true },
      component: require('@/views/overseasSales/chanceManage/business/view.vue').default
    },
    {
      path: 'business/edit',
      name: 'DcCosOFbuBusinessEdit',
      meta: { title: '编辑商机' },
      component: require('@/views/overseasSales/chanceManage/business/edit.vue').default
    },
    {
      path: 'visitorProgram',
      name: 'DcCosOFbuVisitorProgram',
      meta: { title: '访客计划' },
      component: require('@/views/overseasSales/followUpManage/visitorProgram/index.vue').default
    },
    {
      path: 'visitorProgram/add',
      name: 'DcCosOFbuVisitorProgramAdd',
      meta: { title: '新增访客计划' },
      component: require('@/views/overseasSales/followUpManage/visitorProgram/add.vue').default
    },
    {
      path: 'visitorProgram/edit',
      name: 'DcCosOFbuVisitorProgramEdit',
      meta: { title: '编辑访客计划' },
      component: require('@/views/overseasSales/followUpManage/visitorProgram/edit.vue').default
    },
    {
      path: 'visitorProgram/view',
      name: 'DcCosOFbuVisitorProgramView',
      meta: { title: '访客计划详情', noCache: true },
      component: require('@/views/overseasSales/followUpManage/visitorProgram/view.vue').default
    },
    {
      path: 'followUpRecord',
      name: 'DcCosOFbuFollowUpRecord',
      meta: { title: '跟进记录' },
      component: require('@/views/overseasSales/followUpManage/followUpRecord/index.vue').default
    },
    {
      path: 'followUpRecord/add',
      name: 'DcCosOFbuFollowUpRecordAdd',
      meta: { title: '跟进记录新增' },
      component: require('@/views/overseasSales/followUpManage/followUpRecord/add/index.vue').default
    },
    {
      path: 'followUpRecord/edit',
      name: 'DcCosOFbuFollowUpRecordEdit',
      meta: { title: '跟进记录编辑' },
      component: require('@/views/overseasSales/followUpManage/followUpRecord/edit/index.vue').default
    },
    {
      path: 'followUpRecord/view',
      name: 'DcCosOFbuFollowUpRecordView',
      meta: { title: '跟进记录详情', noCache: true },
      component: require('@/views/overseasSales/followUpManage/followUpRecord/view/index.vue').default
    },
    {
      path: 'followUpRecord/commit',
      name: 'DcCosOFbuFollowUpRecordCommit',
      meta: { title: '跟进记录评论' },
      component: require('@/views/overseasSales/followUpManage/followUpRecord/commit/index.vue').default
    },
    {
      path: 'followUpRecord/visitingPlan',
      name: 'DcCosOFbuFollowUpRecordVisitingPlan',
      meta: { title: '完成拜访' },
      component: require('@/views/overseasSales/followUpManage/followUpRecord/followVisitingPlan/index.vue').default
    },
    {
      path: 'businessRuleSetting/customerCodeRating',
      name: 'DcCosOFbuCustomerCodeRating',
      meta: { title: '客户代码评分' },
      component: require('@/views/overseasSales/businessRuleSetting/customerCodeRating/index.vue').default
    },
    {
      path: 'businessRuleSetting/ratingRules',
      name: 'DcCosOFbuRatingRules',
      meta: { title: '评级规则' },
      component: require('@/views/overseasSales/businessRuleSetting/ratingRules/index.vue').default
    },
    {
      path: 'businessRuleSetting/transactionCustomerEquivalentStatus',
      name: 'DcCosOFbuTransactionCustomerEquivalentStatus',
      meta: { title: '成交客户当量状态' },
      component: require('@/views/overseasSales/businessRuleSetting/transactionCustomerEquivalentStatus/index.vue')
        .default
    },
    {
      path: 'followRuleSetting',
      name: 'DcCosOFbuFollowRuleSetting',
      meta: { title: '跟进规则设置' },
      component: require('@/views/overseasSales/followRuleSetting/index.vue').default
    },
    {
      path: 'businessRuleSetting/volumeOfBusinessLevel',
      name: 'DcCosOFbuVolumeOfBusinessLevel',
      meta: { title: '成交额档次' },
      component: require('@/views/overseasSales/businessRuleSetting/ratingRules/index.vue').default
    },
    {
      path: 'businessRuleSetting/lossWarning',
      name: 'DcCosOFbuLossWarning',
      meta: { title: '流失预警' },
      component: require('@/views/overseasSales/businessRuleSetting/lossWarning/index.vue').default
    },
    {
      path: 'businessRuleSetting/transactionVolume',
      name: 'DcCosOFbuTransactionVolume',
      meta: { title: '成交额' },
      component: require('@/views/overseasSales/businessRuleSetting/transactionVolume/index.vue').default
    },
    {
      path: 'businessRuleSetting/customerChangeTask',
      name: 'DcCosOFbuCustomerChangeTask',
      meta: { title: '客户转换任务' },
      component: require('@/views/overseasSales/businessRuleSetting/customerChangeTask/index.vue').default
    },
    {
      path: 'customerProcessing/lossCustomer',
      name: 'DcCosOFbuLossCustomer',
      meta: { title: '流失客户/终止合作' },
      component: require('@/views/overseasSales/customerProcessing/lossCustomer/index.vue').default
    },
    {
      path: 'customerProcessing/blacklist',
      name: 'DcCosOFbuBlacklist',
      meta: { title: '黑名单' },
      component: require('@/views/overseasSales/customerProcessing/blacklist/index.vue').default
    },
    {
      path: 'customerProcessing/cluesAudit',
      name: 'DcCosOFbuCluesAudit',
      meta: { title: '线索审核' },
      component: require('@/views/overseasSales/customerProcessing/cluesAudit/index.vue').default
    },
    {
      path: 'administrativeRegion',
      name: 'DcCosOFbuAdministrativeRegion',
      meta: { title: '行政区域' },
      component: require('@/views/overseasSales/administrativeRegion/index.vue').default
    },
    {
      path: 'registerLinksRecord',
      name: 'DcCosOFbuRegisterLinksRecord',
      meta: { title: '注册链接发送记录' },
      component: require('@/views/overseasSales/registerLinksRecord/index.vue').default
    },
    {
      path: 'exportCenter/ofbu',
      name: 'DcCosOFbuExportCenter',
      meta: { title: '导出中心' },
      component: require('@/views/yuntuSales/exportCenter/index.vue').default
    },
    {
      path: 'overseasSales/example',
      name: 'DcCosOFbuExample',
      meta: { title: 'Demo页' },
      component: require('@/views/example/index.vue').default
    },
    {
      path: 'infrastructure/serviceParamSetting',
      name: 'DcCosServiceParamSetting',
      meta: { title: '商机' },
      component: require('@/views/overseasSales/infrastructure/serviceParamSetting/index.vue').default
    },
    {
      path: 'baseSetting/areaCodeInformation',
      name: 'DcCosAreaCodeInformation',
      meta: { title: '区号信息' },
      component: require('@/views/overseasSales/baseSetting/areaCodeInformation/index.vue').default
    },
    {
      path: 'timeZoneSetting',
      name: 'DcCosOFbuTimeZoneSetting',
      meta: { title: '员工时区设置' },
      component: require('@/views/overseasSales/timeZoneSetting/index.vue').default
    },
    {
      path: 'followChangeFeedback',
      name: 'DcCosOFbuFollowChangeFeedback',
      meta: { title: '异动反馈情况' },
      component: require('@/views/overseasSales/analysis/followChangeFeedback/index.vue').default
    },
    {
      path: 'newClientEvaluation',
      name: 'DcCosOFbuNewClientEvaluationPage',
      meta: { title: '新客评审' },
      component: require('@/views/overseasSales/clueManage/newClientEvaluation/index.vue').default
    },
    {
      path: 'newClientEvaluation/add',
      name: 'DcCosOFbuNewClientEvaluationAdd',
      meta: { title: '新增新客评审' },
      component: require('@/views/overseasSales/clueManage/newClientEvaluation/add.vue').default
    },
    {
      path: 'newClientEvaluation/edit',
      name: 'DcCosOFbuNewClientEvaluationEdit',
      meta: { title: '编辑新客评审' },
      component: require('@/views/overseasSales/clueManage/newClientEvaluation/edit.vue').default
    },
    {
      path: 'newClientEvaluation/view',
      name: 'DcCosOFbuNewClientEvaluationView',
      meta: { title: '新客评审详情' },
      component: require('@/views/overseasSales/clueManage/newClientEvaluation/view.vue').default
    },
    {
      path: 'accountActivation',
      name: 'DcCosOFbuAccountActivationPage',
      meta: { title: '客户激活' },
      component: require('@/views/overseasSales/customerCenter/accountActivation/index.vue').default
    },
    {
      path: 'accountActivation/add',
      name: 'DcCosOFbuAccountActivationAdd',
      meta: { title: '新增客户激活' },
      component: require('@/views/overseasSales/customerCenter/accountActivation/add.vue').default
    },
    {
      path: 'accountActivation/edit',
      name: 'DcCosOFbuAccountActivationEdit',
      meta: { title: '编辑客户激活' },
      component: require('@/views/overseasSales/customerCenter/accountActivation/edit.vue').default
    },
    {
      path: 'accountActivation/view',
      name: 'DcCosOFbuAccountActivationDetail',
      meta: { title: '客户激活详情' },
      component: require('@/views/overseasSales/customerCenter/accountActivation/view.vue').default
    },
    {
      path: 'activityCode',
      name: 'DcCosOFbuActivityCode',
      meta: { title: '市场活动管理' },
      component: require('@/views/overseasSales/marketing/activityCode/index.vue').default
    },
    {
      path: 'activityCode/add',
      name: 'DcCosOFbuActivityCodeAdd',
      meta: { title: '新增市场活动' },
      component: require('@/views/overseasSales/marketing/activityCode/add.vue').default
    },
    {
      path: 'activityCode/edit',
      name: 'DcCosOFbuActivityCodeEdit',
      meta: { title: '编辑市场活动' },
      component: require('@/views/overseasSales/marketing/activityCode/edit.vue').default
    },
    {
      path: 'activityCode/view',
      name: 'DcCosOFbuActivityCodeView',
      meta: { title: '市场活动详情', noCache: true },
      component: require('@/views/overseasSales/marketing/activityCode/view.vue').default
    },
    {
      path: 'templateManage',
      name: 'DcCosOFbuTemplateManage',
      meta: { title: '模版管理' },
      component: require('@/views/overseasSales/marketing/templateManage/index.vue').default
    }
  ]
}

export default routerItem
